import type { SearchParams } from '$lib/services/urls/searchParams';
import type { Page } from '@sveltejs/kit';
import type { AdFormat } from '../constants';
import type { AdId } from '../types';
import { getDevice } from '$lib/components/advertising/utils';
import {
	isMapPoiListPage,
	isRouteSearchPageContext,
	isTrafficPage,
	isZoiPageContext,
} from '$lib/services/urls/routeIds';
import { routesPagename } from '$lib/services/urls/routesPagename';
import { setupGoogleAds } from '../google';
import { addScriptTag } from '../script';
import {
	ITALIA_CLIENT_ID,
	italiaFormatPositionMapping,
	poiListItaliaPageIdByCategory,
} from './constants';

export function getItaliaAdUnit(
	adFormat: AdFormat,
	page: Page,
	searchParams: SearchParams,
	adId: AdId,
) {
	const pageName = getItaliaPageName(page, searchParams, adId);
	return `/${ITALIA_CLIENT_ID}/viamichelin/${pageName}/${italiaFormatPositionMapping[adFormat]}`;
}

export function getItaliaPageName(page: Page, searchParams: SearchParams, adId: AdId) {
	if (page.url.pathname === '/' && page.url.search === '') {
		return 'hp';
	}
	if (isMapPoiListPage(page.route) && searchParams.poiCategories?.length === 1) {
		const category = searchParams.poiCategories[0];
		return poiListItaliaPageIdByCategory[category];
	}
	if (isMapPoiListPage(page.route) && (searchParams.poiCategories?.length ?? 0) > 1) {
		return searchParams.selectedAddress?.address ? routesPagename.MAP_RESULT : 'map.search';
	}
	if (isTrafficPage(page.route)) {
		return searchParams.selectedAddress?.address ? 'traffico.search' : 'traffico.result';
	}
	if (isRouteSearchPageContext(page.route) || isZoiPageContext(page.route)) {
		return routesPagename.ROUTE_EXPLORATION;
	}
	if (adId === 'itinerary-results-loading') {
		return 'itinerary.loading';
	}
	if (adId.startsWith('tracking-iti-result')) {
		return routesPagename.ITINERARY_RESULT;
	}
	return 'ros';
}

export function setupItaliaAds() {
	window.pubAdsCfg = window.pubAdsCfg || { section: {}, customCriteria: {} };
	setupGoogleAds();
	addScriptTag('iol-ad-script', 'https://www.iolam.it/js/iam2.0.js?ns=partner/web/viamichelin/1.0', { attributes: { fetchpriority: 'low' } });
}

export function getAdId(adId: string) {
	const device = getDevice();
	return adId === 'map-banner' ? 'adwallpaper' : device === 'mobile' ? 'admputop2' : 'admputop';
}
